var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6V8.61222C6 9.16332 5.35724 9.46437 4.93388 9.11157L0.599212 5.49934C0.287372 5.23948 0.287372 4.76052 0.599213 4.50066L4.93388 0.888433C5.35724 0.53563 6 0.836683 6 1.38778V4H10C12.1217 4 14.1566 4.84285 15.6569 6.34315C17.1571 7.84344 18 9.87827 18 12C18 14.1217 17.1571 16.1566 15.6569 17.6569C14.1566 19.1571 12.1217 20 10 20H7C6.44772 20 6 19.5523 6 19C6 18.4477 6.44772 18 7 18H10C11.5913 18 13.1174 17.3679 14.2426 16.2426C15.3679 15.1174 16 13.5913 16 12C16 10.4087 15.3679 8.88258 14.2426 7.75736C13.1174 6.63214 11.5913 6 10 6H6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.7bdcdefd836913b4ad0d051ea6ec5d7d.svg";
export { ForwardRef as ReactComponent };